import { useCallback } from 'react';

import { useNavigation, useRouter } from 'expo-router';

import { TRANSITION_ANIMATION_TIME_MS } from 'utils/constants';

/**
 * dismiss all modals and go to a new screen.
 * if you try to do this without this sometimes it doesn't work reliably
 * This seems to be fixed on expo-router v4 but we aren't there yet
 * TODO retest and probably remove on expo-router v4
 */
export const useDismissAllAndNavigate = () => {
  const router = useRouter();
  return useCallback(
    async (...args: Parameters<typeof router.navigate>) => {
      router.canDismiss() && router.dismissAll();
      await wait(100); // 0 works but 100 to be safe
      router.navigate(...args);
    },
    [router]
  );
};

/**
 * dismiss all modals and go to a new screen.
 * if you try to do this without this sometimes it doesn't work reliably
 * This seems to be fixed on expo-router v4 but we aren't there yet
 * TODO retest and probably remove on expo-router v4
 */
export const useDismissAndReplace = () => {
  const router = useRouter();
  return useCallback(
    async (...args: Parameters<typeof router.replace>) => {
      router.canDismiss() && router.dismissAll();
      await wait(100); // 0 works but 100 to be safe
      router.replace(...args);
    },
    [router]
  );
};

/**
 * When a ton of custom animations are in play around dismiss this works better than other methods and is dynamic per the situation
 * TODO retest if necessary on expo-router v4
 */
export const useDismissAllAndNavigateSlowly = () => {
  const navigation = useNavigation();
  const router = useRouter();

  return useCallback(
    async (url: string) => {
      let navState = navigation.getState();
      let count = 0; // So we don't have a while(true) somehow!

      // Continue checking until we see that the route stack is at the root level.
      // Here we assume that "root" is when navState.routes has length 1.
      while (navState.routes.length > 1 && count < 10) {
        router.dismiss();
        await wait(TRANSITION_ANIMATION_TIME_MS + 50); // 50 safety margin on animation finish
        navState = navigation.getState();
        count++;
      }

      await wait(TRANSITION_ANIMATION_TIME_MS + 50); // 50 safety margin on animation finish

      router.navigate(url);
    },
    [navigation, router]
  );
};

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
